export const SpotifyPlacement = {
  landingPage: 'Landing Page Only',
  allPages: 'All Pages',
};

export const ArticleComponent = {
  wysiwyg: 'wysiwyg.text-field',
  videoUpload: 'video.video-upload',
  videoEmbed: 'video.video-embed',
  inlinePhoto: 'photo.inline-photo',
  blockQuote: 'block-quote.block-quote',
  productHeading: 'featured-products-header.featured-products-header',
  product: 'product.product',
};
